import React, { useEffect } from "react";
import { Alert, Snackbar } from "@mui/material";

export default function SnackUI({ state, setState, status, message }) {
  console.log(
    "state of snack bar ============================================ ",
    state,
    "status",
    status,
    "message",
    message
  );

  const handleClose = () => {
    console.log("handleClose", state);
    setState(false); // this is enough
  };

  useEffect(() => {
    if (!state) return;
    const timeoutId = setTimeout(() => {
      setState(false);
    }, 4000);

    return () => clearTimeout(timeoutId); // cleanup
  }, [state]);

  return (
    <Snackbar
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      open={state}
      onClose={handleClose}
      //   autoHideDuration={3000}
      sx={{ zIndex: 99999999999 }}
    >
      <Alert
        onClose={handleClose}
        severity={status === 200 ? "success" : "error"}
        sx={{ width: "100%", zIndex: 99999999999 }}
      >
        {message || "Something went wrong"}
      </Alert>
    </Snackbar>
  );
}
